import { callApi } from './api';
import FileModel from '@/models/file';
import { useQuery } from '@tanstack/react-query';

const filesApiUrl = import.meta.env.VITE_API_URL_V1 + '/files';

export const uploadFile = async ({ file, path, name, contentType }: { file: string; path: string; name: string; contentType: string }) => {
    return callApi<FileModel>({
        url: `${filesApiUrl}`,
        method: 'POST',
        data: { file, path, name, contentType },
    });
};

/**
 * Uploads and returns a PERMANENT (non-expiring) URL. Use for assets whose URL
 * is stored/baked verbatim — e.g. inline images inside a blog post's HTML body,
 * where a 1-hour signed URL (what `uploadFile` returns) would break the image.
 * Cover images keep using `uploadFile` because the API stores their fileId and
 * re-resolves a fresh signed URL on each read.
 */
export const uploadPermanentFile = async ({ file, path, name, contentType }: { file: string; path: string; name: string; contentType: string }) => {
    return callApi<{ url: string }>({
        url: `${filesApiUrl}/permanent`,
        method: 'POST',
        data: { file, path, name, contentType },
    });
};

export const getFile = async (fileId: string) => {
    return callApi<FileModel>({
        url: `${filesApiUrl}/?fileId=${fileId}`,
        method: 'GET',
    });
};
export const useFile = (fileId: string) => {
    return useQuery({
        queryKey: ['file', fileId],
        queryFn: () => getFile(fileId),
        enabled: !!fileId,
    });
};

export const deleteFile = async ({ fileId }: { fileId: string }) => {
    return callApi({
        url: `${filesApiUrl}/${fileId}`,
        method: 'DELETE',
    });
};
